import { CellContext } from "@tanstack/react-table";
import { memo } from "react";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { Entity } from "../../../common/types/entity";
import { TransactionListItemDto } from "../../../common/types/transaction";
import { ViewOptions } from "../../../common/types/views/views";
import { EntityIcon } from "../../entity/EntityIcon";
import { BLOCK_EVENT_KEY } from "../../views/ViewTable";
import { TransactionEntityPopover } from "../TransactionEntityPopover";
import { useChangeTransactionEntity } from "../useChangeTransactionEntity";
import { useChangeTransactionToPersonal } from "../useChangeTransactionToPersonal";
import { ClickableContainer } from "../../general/ClickableContainer";
import styles from "./EntityCell.module.scss";

export const EntityCell = memo(
    ({ row, getValue, table }: CellContext<TransactionListItemDto, Entity>) => {
        const changeToBusiness = useChangeTransactionEntity(row.original);
        const changeToPersonal = useChangeTransactionToPersonal(row.original);
        const tableOptions = (table.options.meta as any).options as ViewOptions;

        if (tableOptions?.readonly) {
            return (
                <div>
                    <EntityIcon entity={getValue()} size="xs" />
                </div>
            );
        }

        return (
            <TransactionEntityPopover
                transaction={row.original}
                onChangeToPersonal={() => {
                    changeToPersonal.mutate();
                }}
                onChangeToBusiness={(entity) => {
                    changeToBusiness.mutate(entity);
                }}
            >
                <OverlayTrigger
                    overlay={
                        <Tooltip id={`entity-popover-tooltip`}>
                            {getValue().name}
                        </Tooltip>
                    }
                >
                    <ClickableContainer
                        className={styles.innerButton}
                        onClick={(e: any) => {
                            e[BLOCK_EVENT_KEY] = true;
                        }}
                    >
                        <div>
                            <EntityIcon entity={getValue()} size="xs" />
                        </div>
                    </ClickableContainer>
                </OverlayTrigger>
            </TransactionEntityPopover>
        );
    },
);
